import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import Button from 'src/components/Button';

const Table = styled('table')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  width: 100%;
  font-size: var(--ph-text-sm);
  box-shadow: var(--ph-box-shadow-sm);
  border-collapse: collapse;

  thead {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-100);
    text-align: left;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: var(--white);
    padding: 0 10px;

    th {
      padding: 5px 10px;
      font-weight: 400;
    }
  }

  tbody {
    td {
      padding: 8px 10px;
      font-size: var(--ph-text-sm);
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: var(--black);

      span {
        color: var(--ph-gray-50);
      }
    }
  }
`;

const StatusRow = styled('tr')`
  &.active td {
    font-weight: normal;
  }
`;

const StatusIcon = styled(Svg)`
  width: 12px;
  margin-right: 10px;
  position: relative;
  top: 0;
`;

const StatusButton = styled(Button)`
  min-width: 0;
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  color: var(--white);
  height: 32px;
  padding-left: 12px;
  padding-right: 12px;

  &.disabled {
    background-color: var(--ph-gray-50) !important;
    color: var(--ph-gray-300);
    cursor: not-allowed;

    &:focus {
      box-shadow: none !important;
    }
  }
`;

const DashRow = styled('tr')`
  td {
    height: 1px;
    padding: 0 !important;
    margin: 0 10px;

    &::before {
      content: '';
      display: block;
      height: 1px;
      background-color: var(--ph-gray-500);
      opacity: 0.3;
      margin: 0 35px;
    }
  }
`;

const Title = styled('span')`
  color: var(--black);
  font-size: var(--ph-heading-five);
  margin: 10px 10px 0 !important;
  display: inline-block;
`;

const Line = styled('hr')`
  border: 0;
  height: 1px;
  width: 227.5%;
  padding: 0;
  background: var(--ph-gray-50);
`;

export default {
  Table,
  StatusRow,
  StatusIcon,
  StatusButton,
  DashRow,
  Title,
  Line,
};
